module.exports = __webpack_public_path__ + "img/pop_bg.d14ff5eb.png";